import ct from 'countries-and-timezones';

const getTypeOfOffset = (offset) => {
  if (offset === 0) return 0;
  if (offset > 0) return 1;
  return 2;
};

export const getTimezonesOptions = () => {
  const countries = ct.getAllTimezones();
  return Object.values(countries)
    .sort((a, b) => {
      const catA = getTypeOfOffset(a.utcOffset);
      const catB = getTypeOfOffset(b.utcOffset);

      const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (currentTimezone === a.name) {
        return -1;
      } else if (currentTimezone === b.name) {
        return 1;
      }

      if (catA !== catB) {
        return catA - catB;
      }

      if (a.utcOffset !== b.utcOffset) {
        return a.utcOffset - b.utcOffset;
      }

      return a.name.localeCompare(b.name);
    })
    .map(({ name, utcOffset, utcOffsetStr }) => ({
      value: name,
      label: `(UTC${utcOffsetStr}) - ${name}`,
      searchString: `UTC${utcOffsetStr}${name}${utcOffset}`,
    }));
};
